export interface IWorkExperienceFormData {
  workExperiences: IWorkExperience[];
}

export enum WorkType { // name copied from backend
  REMOTE = 'REMOTE',
  ON_SITE = 'ON_SITE',
  HYBRID = 'HYBRID',
}

export enum EmploymentType {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  FREELANCE = 'FREELANCE',
  CONTRACT = 'CONTRACT',
  INTERNSHIP = 'INTERNSHIP',
  APPRENTICESHIP = 'APPRENTICESHIP',
  SEASONAL = 'SEASONAL',
}

export interface IWorkExperience {
  id?: string;
  isActiveAthlete: boolean;
  title: string;
  employmentType: EmploymentType;
  companyName: string;
  location: string;
  workType: WorkType;
  responsibilities?: string | null;
  startDate: Date;
  endDate?: Date;
  activeWork: boolean;

  verified?: boolean;
}

export interface GetWorkExperienceReq {}
export interface GetWorkExperienceRes extends IWorkExperience {}

export interface CreateWorkExperienceReq extends Omit<IWorkExperience, 'id'> {}
export interface CreateWorkExperienceRes extends IWorkExperience {}

export interface UpdateWorkExperienceReq extends IWorkExperience {}
export interface UpdateWorkExperienceRes extends IWorkExperience {}

export interface DeleteWorkExperienceRes extends IWorkExperience {}
